/**
 * Banner opt-in para notificações push (PWA candidato).
 */
import React, { useCallback, useEffect, useState } from 'react';
import {
  dismissPushOptIn,
  getCandidatePushStatus,
  pushSubscribeErrorMessage,
  subscribeCandidatePush,
} from '../../pwa/candidatePush';

export function CandidatePushOptInBanner() {
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let cancelled = false;
    getCandidatePushStatus().then((s) => {
      if (!cancelled) setVisible(!!s.showOptIn);
    });
    return () => { cancelled = true; };
  }, []);

  const onDismiss = useCallback(() => {
    dismissPushOptIn();
    setVisible(false);
  }, []);

  const onEnable = useCallback(async () => {
    setBusy(true);
    setErrorMessage('');
    try {
      const result = await subscribeCandidatePush();
      if (result.ok) {
        setVisible(false);
        return;
      }
      setErrorMessage(pushSubscribeErrorMessage(result.reason, result.detail));
    } catch {
      setErrorMessage(pushSubscribeErrorMessage('subscribe_failed'));
    } finally {
      setBusy(false);
    }
  }, []);

  if (!visible) return null;

  return (
    <div
      style={{
        marginBottom: 16,
        padding: '12px 14px',
        borderRadius: 8,
        border: errorMessage ? '1px solid #FECACA' : '1px solid #BBF7D0',
        backgroundColor: errorMessage ? '#FEF2F2' : '#F0FDF4',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
        <div style={{ fontSize: 14, color: errorMessage ? '#991B1B' : '#166534', fontWeight: 600 }}>
          🔔 Avisos da inscrição
        </div>
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Fechar"
          style={{ border: 'none', background: 'transparent', color: '#6B7280', cursor: 'pointer', fontSize: 18 }}
        >
          ×
        </button>
      </div>
      <p style={{ margin: 0, fontSize: 13, color: '#374151' }}>
        Receba avisos quando o cronograma ou a situação da sua inscrição mudar.
      </p>
      {errorMessage && (
        <p
          role="alert"
          style={{
            margin: 0,
            fontSize: 13,
            color: '#991B1B',
            lineHeight: 1.45,
            padding: '8px 10px',
            borderRadius: 6,
            backgroundColor: '#FEE2E2',
          }}
        >
          {errorMessage}
        </p>
      )}
      <button
        type="button"
        disabled={busy}
        onClick={onEnable}
        style={{
          alignSelf: 'flex-start',
          padding: '8px 14px',
          borderRadius: 6,
          border: 'none',
          backgroundColor: '#16A34A',
          color: '#fff',
          fontSize: 14,
          fontWeight: 600,
          cursor: busy ? 'wait' : 'pointer',
        }}
      >
        {busy ? 'Ativando…' : 'Ativar avisos'}
      </button>
    </div>
  );
}
